import reset from "./resetEvents.js";
class Tabs {
    constructor(tablist) {
        this.tablist = tablist;

        this.init();
    }

    init() {
        this.tabs();
    }

    changeTabs(e) {
        const target = e.currentTarget;
        const parent = target.parentNode;
        const id = target.getAttribute("aria-controls");
        const buttons = parent.querySelectorAll("[aria-controls]");

        // Remove all current selected tabs
        parent
            .querySelectorAll('[aria-selected="true"]')
            .forEach((t) => t.setAttribute("aria-selected", "false"));

        // Set this tab as selected
        target.setAttribute("aria-selected", "true");

        // Hide all related tab panels
        buttons.forEach((button) => {
            document
                .getElementById(button.getAttribute("aria-controls"))
                .setAttribute("aria-hidden", "true");
        });

        // Show the selected panel
        this.open_panel = document.querySelector(`#${id}`);
        this.open_panel.setAttribute("aria-hidden", "false");
        setTimeout(() => {
            reset.refreshCarousels(this.open_panel);
        }, 1);
    }

    tabs() {
        const tabs = this.tablist.querySelectorAll('[role="tab"]');

        if (!tabs.length) return;

        // Add a click event handler to each tab
        tabs.forEach((tab) => {
            tab.addEventListener("click", this.changeTabs.bind(this));
        });

        // Enable arrow navigation between tabs in the tab list
        let tabFocus = 0;

        this.tablist.addEventListener("keydown", (e) => {
            // Move right
            if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
                tabs[tabFocus].setAttribute("tabindex", -1);
                if (e.key === "ArrowRight") {
                    tabFocus++;
                    // If we're at the end, go to the start
                    if (tabFocus >= tabs.length) {
                        tabFocus = 0;
                    }
                    // Move left
                } else if (e.key === "ArrowLeft") {
                    tabFocus--;
                    // If we're at the start, move to the end
                    if (tabFocus < 0) {
                        tabFocus = tabs.length - 1;
                    }
                }

                tabs[tabFocus].setAttribute("tabindex", 0);
                tabs[tabFocus].focus();
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const tablists = document.querySelectorAll("[role='tablist']");

    if (tablists) {
        tablists.forEach((tablist) => {
            new Tabs(tablist);
        });
    }
});
